import moment from "moment";
import React, { lazy, Suspense } from "react";
import { instance } from "../../../../../Actions/AxiosInstance";
import DrawerHeader from "../../../../../Component/Headers/drawerHeader";
import Loader from "../../../../../Component/Loader";
import biometric from "../../../../../Assets/Icons/Biometric/biometric-outline-16px.svg";
import desktop from "../../../../../Assets/Icons/Web/web-16px.svg";
import IconLabel from "../../../../../Component/Labels/IconLabel";
import location from "../../../../../Assets/newicons/user-interface/location/outline/location-outline-16px.svg";
import mobileicon from "../../../../../Assets/newicons/user-interface/mobile/outline/mobile-outline-16px.svg";
import { FEATUREKEYS } from "../../../../../Constants/Featurekeys";
import {
  convertDateForBackend,
  convertDateTimeForBackend,
  getFormattedDate,
} from "../../../../../Utils";
import AllLogsComponent from "./AllLogs";
import "./index.style.css";
// import ClockIn from "./ClockIn";
// import Workrequest from "./WorkRequest";

const BulkRegularizeComponent = lazy(() => import("./BulkRegularize"));
const AutoregularizeComponent = lazy(() => import("./Autoregularize"));
const WorkRequestComponent = lazy(() => import("./WorkRequest"));
const ExtratimeComponent = lazy(() => import("./Extratime"));
const ClockInComponent = lazy(() => import("./ClockIn"));
// const C = (p) =>
//   window.location.pathname === "/" ? (
//     <Suspense fallback={<Loader />}>{p.Child}</Suspense>
//   ) : (
//     <Suspense fallback={<Loader />}>{p.Child}</Suspense>
//   );

const C = (p) => <Suspense fallback={<Loader />}>{p.Child}</Suspense>;

const BulkRegularize = (p) => <C Child={<BulkRegularizeComponent {...p} />} />;
const Autoregularize = (p) => <C Child={<AutoregularizeComponent {...p} />} />;
const Workrequest = (p) => <C Child={<WorkRequestComponent {...p} />} />;
const Extratime = (p) => <C Child={<ExtratimeComponent {...p} />} />;
const ClockIn = (p) => <C Child={<ClockInComponent {...p} />} />;

export default class DrawerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      employeePunchedLogs: [],
      employeePunchedLogsDeleted: [],
      ...this.props,
    };

    //   this.delectBulkRdata = this.delectBulkRdata.bind(this);
    //   this.updateBulkRFromTime = this.updateBulkRFromTime.bind(this);
    //   this.createBulkRegRequest = this.createBulkRegRequest.bind(this);
    //   this.AddNewBulkR = this.AddNewBulkR.bind(this);
    //   this.updateBulkRegComment = this.updateBulkRegComment.bind(this);
  }

  componentDidMount() {
    this.GetWorkRequest();
  }

  GetWorkRequest = (shiftDate) => {
    const data = {
      employeeid: this.props.employeeid,
      shiftdate: moment(shiftDate).format("YYYY-MM-DD"),
    };
    instance
      .post("attendance/getworkrequest", data)
      .then((result) => {
        this.setState({ workRequestType: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  handleBookExpandClick = () => {
    if (this.state.expanded) {
      const insertlogs = this.state.employeePunchedLogs.filter(
        (x) => x.inserted == true,
      );
      const updatelogs = this.state.employeePunchedLogs.filter(
        (x) => x.updated == true && x.inserted == false,
      );
      if (updatelogs.length == 0 && insertlogs.length == 0) {
        this.props.enqueueSnackbar("There are no changes to save", {
          variant: "error",
        });
      } else if (updatelogs.length != 0 && insertlogs.length == 0) {
        if (
          !this.props.recipient ||
          (this.props.recipient && this.props.recipient.length == 0)
        ) {
          this.props.enqueueSnackbar(
            "Something went wrong please try again later",
            { variant: "error" },
          );
          return;
        } else {
          updatelogs.map((log) => {
            if (log.selectedWorkRequest == null) {
              this.props.enqueueSnackbar("Please select work request", {
                variant: "error",
              });
            } else if (log.message == null) {
              this.props.enqueueSnackbar("Please add message", {
                variant: "error",
              });
            } else if (log.transactiondatetime == null) {
              this.props.enqueueSnackbar("Please select log time", {
                variant: "error",
              });
            } else {
              const getDeleteStr = (data = []) => {
                const resArr = data.map((x) => x.transactionid);
                return resArr.join(",");
              };
              const data = {
                employeeid: this.props.employeeid,
                requesttypeid: 1,
                attendancerequest: [
                  {
                    shiftdate: convertDateForBackend(
                      this.state.selectedshiftdate,
                    ),
                    comment: this.state.comment,
                    insert:
                      insertlogs.length == 0
                        ? null
                        : insertlogs.map((x) => ({
                            transactionid: 0,
                            ipaddress: x.ipaddress,
                            transactionlocation: x.transactionlocation,
                            transactiondatetime: convertDateTimeForBackend(
                              x.transactiondatetime,
                            ),
                            message: x.message,
                          })),
                    delete:
                      this.state.employeePunchedLogsDeleted.length == 0
                        ? null
                        : getDeleteStr(this.state.employeePunchedLogsDeleted),
                    update:
                      updatelogs.length == 0
                        ? null
                        : updatelogs.map((x) => ({
                            transactionid: x.transactionid,
                            ipaddress: x.ipaddress,
                            transactionlocation: x.transactionlocation,
                            transactiondatetime: convertDateTimeForBackend(
                              x.transactiondatetime,
                            ),
                            message: x.message,
                          })),
                  },
                ],
                sendersourceid: 1,
                recipient: this.props.recipient,
              };
              instance
                .post("attendance/createattendancelog", data)
                .then((result) => {
                  this.setState((state) => ({
                    expanded: !state.expanded,
                    deleteOpen: [],
                  }));
                  this.props.enqueueSnackbar("saved successfully", {
                    variant: "success",
                  });
                  this.props.closeDrawer();
                })
                .catch((error) => {
                  this.props.enqueueSnackbar(
                    error.response
                      ? error.response.data.error.message
                      : error.message,
                    { variant: "error" },
                  );
                });
            }
          });
        }
      } else if (insertlogs.length != 0) {
        if (
          !this.props.recipient ||
          (this.props.recipient && this.props.recipient.length == 0)
        ) {
          this.props.enqueueSnackbar(
            "Something went wrong please try again later",
            { variant: "error" },
          );
          return;
        } else {
          insertlogs.map((log) => {
            if (log.selectedWorkRequest == null) {
              this.props.enqueueSnackbar("Please select work request", {
                variant: "error",
              });
            } else if (log.message == null) {
              this.props.enqueueSnackbar("Please add message", {
                variant: "error",
              });
            } else if (log.transactiondatetime == null) {
              this.props.enqueueSnackbar("Please select log time", {
                variant: "error",
              });
            } else {
              const getDeleteStr = (data) => {
                const resArr = data.map((x) => x.transactionid);
                return resArr.join(",");
              };
              const data = {
                employeeid: this.props.employeeid,
                requesttypeid: 1,
                attendancerequest: [
                  {
                    shiftdate: convertDateForBackend(
                      this.state.selectedshiftdate,
                    ),
                    comment: this.state.comment,
                    insert:
                      insertlogs.length == 0
                        ? null
                        : insertlogs.map((x) => ({
                            transactionid: 0,
                            ipaddress: x.ipaddress,
                            transactionlocation: x.transactionlocation,
                            transactiondatetime: convertDateTimeForBackend(
                              x.transactiondatetime,
                            ),
                            message: x.message,
                          })),
                    delete:
                      this.state.employeePunchedLogsDeleted.length == 0
                        ? null
                        : getDeleteStr(this.state.employeePunchedLogsDeleted),
                    update:
                      updatelogs.length == 0
                        ? null
                        : updatelogs.map((x) => ({
                            transactionid: x.transactionid,
                            ipaddress: x.ipaddress,
                            transactionlocation: x.transactionlocation,
                            transactiondatetime: convertDateTimeForBackend(
                              x.transactiondatetime,
                            ),
                            message: x.message,
                          })),
                  },
                ],
                sendersourceid: 1,
                recipient: this.props.recipient,
              };
              instance
                .post("attendance/createattendancelog", data)
                .then((result) => {
                  this.setState((state) => ({
                    expanded: !state.expanded,
                    deleteOpen: [],
                  }));
                  this.props.enqueueSnackbar("saved successfully", {
                    variant: "success",
                  });
                })
                .catch((error) => {
                  this.props.enqueueSnackbar(
                    error.response
                      ? error.response.data.error.message
                      : error.message,
                    { variant: "error" },
                  );
                });
            }
          });
        }
      }
    } else {
      this.setState((state) => ({ expanded: !state.expanded }));
    }
  };

  addNewLog = (index) => {
    const { employeeid } = this.props;
    const { employeePunchedLogs } = this.state;
    employeePunchedLogs.splice(index, 0, {
      inserted: true,
      updated: false,
      transactionid: 0,
      deviceid: 0,
      employeeid,
      deviceserialnumber: "",
      sourceid: 1,
      ipaddress: null,
      latitude: null,
      longitude: null,
      transactionlocation: "",
      devicedirectionid: null,
      transactionstateid: 0,
      selectedWorkRequest: null,
      message: null,
      // "transactiondatetime": this.state.selectedshiftdate,
      transactiondatetime: null,
      attendancelogid: null,
    });
    this.setState({ employeePunchedLogs });
  };

  deleteNewLog = (index) => {
    let employeePunchedLogs = [...this.state.employeePunchedLogs];
    const { employeePunchedLogsDeleted } = this.state;
    if (!employeePunchedLogs[index].inserted) {
      employeePunchedLogsDeleted.push(employeePunchedLogs[index]);
    }

    employeePunchedLogs = employeePunchedLogs.splice(
      employeePunchedLogs.findIndex((item) => item.index == index),
      1,
    );

    const { deleteOpen } = this.state;
    deleteOpen[index] = false;
    this.setState({
      employeePunchedLogs,
      employeePunchedLogsDeleted,
      deleteOpen,
    });
  };

  deleteNewLog2 = (index) => {};

  deleteClose = (index) => {
    this.setState((state) => {
      const { deleteOpen } = state;
      deleteOpen[index] = false;
      return {
        deleteOpen,
      };
    });
  };

  deleteOpen = (index) => {
    this.setState((state) => {
      const { deleteOpen } = state;
      deleteOpen[index] = true;
      return {
        deleteOpen,
      };
    });
  };

  onDattimeChange = (index, value) => {
    if (value.value) {
      // let date = new Date(value.value)
      const employeePunchedLogs = [...this.state.employeePunchedLogs];
      // employeePunchedLogs[index].transactiondatetime = moment(date).format('YYYY-MM-DD HH:mm:ss');
      employeePunchedLogs[index].transactiondatetime = value.value;
      employeePunchedLogs[index].updated = true;
      this.setState({ employeePunchedLogs });
    }
  };

  UpdateWorkRequest = (index, selectedItem) => {
    const employeePunchedLogs = [...this.state.employeePunchedLogs];
    employeePunchedLogs[index].selectedWorkRequest = selectedItem;
    employeePunchedLogs[index].transactionlocation = selectedItem.displayname;
    employeePunchedLogs[index].updated = true;
    this.setState({ employeePunchedLogs });
  };

  updateLogMessage = (index, event) => {
    const employeePunchedLogs = [...this.state.employeePunchedLogs];
    employeePunchedLogs[index].message = event.target.value;
    employeePunchedLogs[index].updated = true;
    this.setState({ employeePunchedLogs });
  };

  autoRegularize = () => {
    if (this.state.regularizeLog.length == 0) {
      this.props.enqueueSnackbar("Please select at-least one log", {
        variant: "error",
      });
      return false;
    }
    instance
      .post("attendance/autoregularize", {
        employeeid: this.props.employeeid,
        regularizelog: this.state.regularizeLog,
      })
      .then((result) => {
        this.props.enqueueSnackbar("Data saved successfully", {
          variant: "success",
        });
        this.props.GetAttendanceLog();
        this.props.closeDrawer();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  render() {
    // const ClockIn = lazy(() => import("./ClockIn"));
    // const Workrequest = lazy(() => import("./WorkRequest"));
    const {
      AllLogs,
      employeePunchedLogs,
      workRequestType,
      expanded,
      deleteOpen,
      autoRegularize,
      regularizeLog,
      ShortDateFormat,
      bulkRegularize,
      bulkRegularizeData,
      currentShift,
      selectedshiftdate,
      // Today,
      // Yesterday,
      currentshiftData,
      extraTimePolicyData,
      // employeePunchedLogs
    } = this.state;
    const Today = moment().format();
    const Tomorrow = moment().add(1, "days").format();
    const Yesterday = moment().subtract(1, "days").format();
    const { IsClockin, extratime } = this.props;
    const IsWorkrequest = !(
      AllLogs ||
      autoRegularize ||
      bulkRegularize ||
      currentShift ||
      IsClockin ||
      extratime
    );
    const updateAttendancelogs =
      this.props.AuthenticationAction.login.features.find(
        (feature) => feature.featureid == FEATUREKEYS.updateAttendancelogs,
      );

    return (
      <div>
        <div className={!bulkRegularize && "padding15 padding-top-0"}>
          {IsClockin && <ClockIn {...this.props} />}
          {IsWorkrequest && <Workrequest {...this.props} {...this.state} />}
          {AllLogs && <AllLogsComponent {...this.props} />}
          {extratime && <Extratime {...this.props} {...this.state} />}
          {autoRegularize && (
            <Suspense fallback={<Loader />}>
              <Autoregularize {...this.state} />
            </Suspense>
          )}
          {bulkRegularize && (
            <Suspense fallback={<Loader />}>
              <BulkRegularize {...this.props} />
            </Suspense>
          )}
          {currentShift ? (
            <div>
              <div>
                <DrawerHeader
                  header="Current Shift"
                  isbackarrow={false}
                  closeDrawer={() => this.props.closeDrawer()}
                />
                <div>
                  <span className="leave-days">Shift Name :</span>{" "}
                  {currentshiftData.shiftname}
                </div>
                <div className="margin-top-20">
                  <span className="leave-days">Shift Begin Date : </span>
                  {currentshiftData.shiftbegintime &&
                    `${getFormattedDate(
                      currentshiftData.shiftbegintime,
                    )} ${moment(currentshiftData.shiftbegintime).format(
                      "hh:mm:ss a",
                    )}`}{" "}
                </div>
                <div className="margin-top-20">
                  <span className="leave-days">Shift End Date : </span>
                  {currentshiftData.shiftendtime &&
                    `${getFormattedDate(
                      currentshiftData.shiftendtime,
                    )} ${moment(currentshiftData.shiftendtime).format(
                      "hh:mm:ss a",
                    )}`}
                </div>
                <div className="margin-top-20">
                  <span className="leave-days">Attendance Policy :</span>
                  {currentshiftData.attendancepolicyname}
                </div>
                <div className="margin-top-20">
                  <span className="leave-days">Device Policy :</span>
                  {currentshiftData.devicepolicyname}
                </div>
                <div className="margin-top-20">
                  <span className="leave-days">Clock in method :</span>
                  <div style={{ display: "flex" }}>
                    {currentshiftData.iswebdevice && (
                      <IconLabel
                        // label="Web clock-in"
                        img={desktop}
                        labelClassNames="small-dark"
                        iconHeight="16"
                        className="margin-right-16 margin-top-8"
                      />
                    )}
                    {currentshiftData.ismobiledevice && (
                      <IconLabel
                        // label="Mobile clock-in"
                        img={mobileicon}
                        labelClassNames="small-dark"
                        iconHeight="16"
                        className="margin-right-16 margin-top-8"
                      />
                    )}
                    {currentshiftData.isbiometricdevice && (
                      <IconLabel
                        img={biometric}
                        labelClassNames="small-dark"
                        iconHeight="16"
                        className="margin-right-16 margin-top-8"
                      />
                    )}
                  </div>
                </div>
                <div className="margin-top-20">
                  <span className="leave-days">Weekly Policy :</span>
                  {currentshiftData.weekoffpolicyname}
                </div>
                <div className="margin-top-20">
                  <span className="leave-days">Extra Time Policy :</span>
                  {extraTimePolicyData &&
                  extraTimePolicyData.extratimepolicyname
                    ? extraTimePolicyData.extratimepolicyname
                    : "-"}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
